<div class="container-fluid" style="padding: 0px;">
  <!-- Collapsible Panels -->
  <!-- Panel 1: Thông tin học phí -->
  <div class="card mb-3">
    <div class="card-header" id="headingHocPhi">
      <h5 class="mb-0">
        <button class="btn btn-link w-100 text-left"
                type="button"
                [class.collapsed]="isHocPhiCollapsed"
                aria-expanded="true"
                aria-controls="collapseHocPhi">
          <i class="fas fa-info-circle mr-2"></i>
          <span>Thông tin học phí</span>
        </button>
      </h5>
    </div>
    <div id="collapseHocPhi" class="collapse" [class.show]="!isHocPhiCollapsed" aria-labelledby="headingHocPhi">
      <div class="card-body">
        <!-- Bảng thông tin học phí cho nhiều tháng -->
        <div class="table-responsive">
          <table class="table table-bordered table-hover">
            <thead class="thead-light">
              <tr>
                <th class="text-center" width="10%">Từ ngày</th>
                <th class="text-center" width="10%">Đến ngày</th>
                <th class="text-center" width="8%">Số buổi</th>
                <th class="text-center" width="12%">Học phí</th>
                <th class="text-center" width="12%">Thực thu</th>
                <th class="text-center" width="30%">Ghi chú</th>
                <th class="text-center" width="8%">Loại học phí</th>
                <th class="text-center" width="10%">Thao tác</th>
              </tr>
            </thead>
            <tbody>
              <!-- Trường hợp có nhiều tháng học phí -->
              <tr *ngFor="let hocPhi of hocPhiList; let i = index"
                  [class.table-primary]="i === 0 && !isOldDebt(hocPhi)"
                  [class.old-debt-row]="isOldDebt(hocPhi)"
                  [class.new-debt-row]="!isOldDebt(hocPhi)">
                <td class="text-center">
                  <span class="form-control-plaintext">
                    {{hocPhi.NgayDangKy | date: 'dd/MM/yyyy'}}
                  </span>
                </td>
                <td class="text-center">
                  <span class="form-control-plaintext">
                    {{hocPhi.NgayKetThuc | date: 'dd/MM/yyyy'}}
                  </span>
                </td>
                <td class="text-center">
                  <span class="form-control-plaintext font-weight-bold">
                    {{hocPhi.SoBuoi | number}}
                  </span>
                </td>
                <td class="text-right">
                  <span class="form-control-plaintext font-weight-bold text-primary">
                    {{hocPhi.GiaPhi | currency:'':'':'1.0-0'}}
                  </span>
                </td>
                <td class="text-right">
                  <span class="form-control-plaintext font-weight-bold text-success">
                    {{hocPhi.ThucThu | currency:'':'':'1.0-0'}}
                  </span>
                </td>
                <td>
                  <div class="form-control-plaintext" style="max-height: 60px; overflow-y: auto;">
                    {{hocPhi.GhiChu || 'Không có nội dung'}}
                  </div>
                </td>
                <td class="text-center">
                  <!-- Hiển thị badge để phân biệt loại công nợ -->
                  <span *ngIf="isOldDebt(hocPhi)"
                        class="badge badge-warning"
                        title="Công nợ cũ">
                    <i class="fas fa-history mr-1"></i>Cũ
                  </span>
                  <span *ngIf="!isOldDebt(hocPhi)"
                        class="badge badge-info"
                        title="Công nợ mới">
                    <i class="fas fa-plus mr-1"></i>Mới
                  </span>
                </td>
                <td class="text-center">
                  <!-- Chỉ hiển thị nút xóa cho công nợ cũ (có Id) -->
                  <button *ngIf="canRemoveRow(i)"
                          type="button"
                          class="btn btn-sm btn-outline-danger"
                          title="Xóa khoản công nợ cũ"
                          (click)="removeHocPhiRow(i)">
                    <i class="fas fa-trash"></i>
                  </button>
                  <!-- Hiển thị icon khóa cho công nợ mới -->
                  <span *ngIf="!canRemoveRow(i)"
                        class="text-muted small"
                        title="Công nợ mới - không thể xóa">
                    <i class="fas fa-lock"></i>
                  </span>
                </td>
              </tr>

              <!-- Trường hợp chỉ có 1 tháng (fallback) -->
              <tr *ngIf="!hocPhiList || hocPhiList.length === 0"
                  class="new-debt-row">
                <td class="text-center">
                  <span class="form-control-plaintext">
                    {{doituongSelect.NgayDangKy | date: 'dd/MM/yyyy'}}
                  </span>
                </td>
                <td class="text-center">
                  <span class="form-control-plaintext">
                    {{doituongSelect.NgayKetThuc | date: 'dd/MM/yyyy'}}
                  </span>
                </td>
                <td class="text-center">
                  <span class="form-control-plaintext font-weight-bold">
                    {{doituongSelect.SoBuoi | number}}
                  </span>
                </td>
                <td class="text-right">
                  <span class="form-control-plaintext font-weight-bold text-primary">
                    {{doituongSelect.GiaPhi | currency:'':'':'1.0-0'}}
                  </span>
                </td>
                <td class="text-right">
                  <span class="form-control-plaintext font-weight-bold text-success">
                    {{doituongSelect.ThucThu | currency:'':'':'1.0-0'}}
                  </span>
                </td>
                <td>
                  <div class="form-control-plaintext" style="max-height: 60px; overflow-y: auto;">
                    {{doituongSelect.GhiChu || 'Không có nội dung'}}
                  </div>
                </td>
                <td class="text-center">
                  <span class="badge badge-info"
                        title="Công nợ mới">
                    <i class="fas fa-plus mr-1"></i>Mới
                  </span>
                </td>
                <td class="text-center">
                  <span class="text-muted small">
                    <i class="fas fa-lock"></i>
                  </span>
                </td>
              </tr>
            </tbody>

            <!-- Footer tổng cộng -->
            <tfoot class="thead-dark">
              <tr>
                <th colspan="2" class="text-center">
                  Tổng cộng
                  <br>
                  <small class="text-muted">
                    ({{getNewDebtRowsCount()}} mới + {{getOldDebtRowsCount()}} cũ)
                  </small>
                </th>
                <th class="text-center">{{getTotalSoBuoi()}}</th>
                <th class="text-right">{{getTotalHocPhi() | currency:'':'':'1.0-0'}}</th>
                <th class="text-right text-success">{{getTotalThucThu() | currency:'':'':'1.0-0'}}</th>
                <th colspan="3"></th>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- Thông tin giảm giá -->
        <div class="form-group row" style="margin-top: 10px;">
          <label class="col-4 col-form-label font-weight-bold">Số tiền giảm/ phần trăm giảm:</label>
          <div class="col-8">
            <input class="form-control"
                   maxlength="20"
                   tabindex="6"
                   style="width:150px;"
                   currencyMask
                   [(ngModel)]="doituongSelect.DuocGiam"
                   (ngModelChange)="changeDuocGiam()"
                   name="value"
                   [placeholder]="'Nhập số tiền giảm hoặc % giảm'"
                   [options]="ngxCurrencyOptions"
                   autocomplete="off" />
            <small class="text-muted">Nhập > 100 là số tiền cố định, ≤ 100 là phần trăm</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Panel 2: Thông tin thu tiền -->
  <div class="card mb-3">
    <div class="card-header" id="headingThuTien">
      <h5 class="mb-0">
        <button class="btn btn-link w-100 text-left"
                type="button"
                [class.collapsed]="isThuTienCollapsed"
                aria-expanded="false"
                aria-controls="collapseThuTien">
          <i class="fas fa-money-bill-wave mr-2"></i>
          <span>Thông tin thu tiền</span>
        </button>
      </h5>
    </div>
    <div id="collapseThuTien" class="collapse" [class.show]="!isThuTienCollapsed" aria-labelledby="headingThuTien">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-4 col-form-label">Quyển số:</label>
              <div class="col-8">
                <input type="text" tabIndex="7" class="form-control" placeholder="Nhập quyển số" [(ngModel)]="phieuThu.QuyenSo">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label">Thu trước:</label>
              <div class="col-8">
                <ng-select #slThuTruoc
                           class="twcollong"
                           [tabIndex]="9"
                           [openOnEnter]="false"
                           [items]="thuTruocOptions"
                           bindValue="id"
                           bindLabel="name"
                           notFoundText="Không có dữ liệu"
                           [searchFn]="comboSearchFn2"
                           (change)="changeThuTruoc($event)"
                           [(ngModel)]="phieuThu.ThuTruoc">
                  <ng-template ng-option-tmp let-item="item">
                    <div class="rTableRow">
                      <div class="rTableCell_1">{{item.name}}</div>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label">Hình thức: <span class="text-danger">*</span></label>
              <div class="col-8">
                <ng-select #slHinhThuc
                           class="twcollong"
                           [tabIndex]="11"
                           [openOnEnter]="false"
                           [items]="inputhinhthucs"
                           bindValue="Id"
                           bindLabel="Ten"
                           notFoundText="Không có dữ liệu"
                           [searchFn]="comboSearchFn2"
                           [(ngModel)]="phieuThu.HinhThuc">
                  <ng-template ng-option-tmp let-item="item">
                    <div class="rTableRow">
                      <div class="rTableCell_1">{{item.Ten}}</div>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-4 col-form-label">Số phiếu: <span class="text-danger">*</span></label>
              <div class="col-8">
                <input type="number" tabIndex="8" class="form-control" placeholder="Nhập số phiếu" [(ngModel)]="phieuThu.SoPhieu">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label">Số tiền: <span class="text-danger">*</span></label>
              <div class="col-8">
                <input class="form-control"
                       maxlength="20"
                       tabindex="10"
                       currencyMask
                       [(ngModel)]="phieuThu.SoTien"
                       name="value"
                       [placeholder]="'Số tiền thu'"
                       [options]="ngxCurrencyOptions"
                       autocomplete="off" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label">Phương thức: <span class="text-danger">*</span></label>
              <div class="col-8">
                <ng-select #slPhuongThuc
                           class="twcollong"
                           [tabIndex]="12"
                           [openOnEnter]="false"
                           [items]="inputphuongthucs"
                           bindValue="Id"
                           bindLabel="Ten"
                           notFoundText="Không có dữ liệu"
                           [searchFn]="comboSearchFn2"
                           [(ngModel)]="phieuThu.PhuongThuc">
                  <ng-template ng-option-tmp let-item="item">
                    <div class="rTableRow">
                      <div class="rTableCell_1">{{item.Ten}}</div>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-4 col-form-label">Ngày nộp: <span class="text-danger">*</span></label>
              <div class="col-8">
                <kendo-dateinput style="width:100%;" tabIndex="13" [format]="'dd/MM/yyyy'" [(value)]="phieuThu.NgayChungTu"></kendo-dateinput>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-2 col-form-label">Ghi chú:</label>
          <div class="col-10">
            <textarea type="text" tabIndex="14" rows="3" class="form-control" placeholder="Nhập ghi chú" [(ngModel)]="phieuThu.GhiChu"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Footer section -->
<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <small class="text-muted">
      <i class="fas fa-info-circle mr-1"></i>
      Các trường có dấu <span class="text-danger">*</span> là bắt buộc
    </small>
  </div>
  <div class="">
    <button *ngIf="!(quyen_sua==false && doituongSelect.Id!=null)"
            type="submit"
            (click)="saveproduct()"
            title="Ấn F9 để lưu"
            class="mb-1 mr-1 btn btn-primary"
            [disabled]="isSubmitting">
      <i class="fas fa-save mr-1"></i>Lưu lại
    </button>
    
    <button class="mb-1 mr-1 btn btn-secondary"
            (click)="closeModal()"
            title="Ấn ESC để thoát">
      <i class="fas fa-times mr-1"></i>Hủy bỏ
    </button>
  </div>
</div>

<!-- CSS cho highlighting rows -->
<style>
  /* CSS cho dòng công nợ cũ (có Id) */
  .old-debt-row {
    background-color: #fff3cd !important; /* Màu vàng nhạt */
    border-left: 4px solid #ffc107 !important; /* Viền trái màu vàng */
    position: relative;
  }

    .old-debt-row:hover {
      background-color: #ffeaa7 !important; /* Màu vàng đậm hơn khi hover */
    }

  /* CSS cho dòng công nợ mới (không có Id) */
  .new-debt-row {
    background-color: #d1ecf1 !important; /* Màu xanh nhạt */
    border-left: 4px solid #17a2b8 !important; /* Viền trái màu xanh */
  }

    .new-debt-row:hover {
      background-color: #bee5eb !important; /* Màu xanh đậm hơn khi hover */
    }

  /* CSS cho badge */
  .badge {
    font-size: 0.75rem;
    padding: 0.25em 0.5em;
    border-radius: 0.25rem;
  }

  .badge-warning {
    background-color: #ffc107;
    color: #212529;
  }

  .badge-info {
    background-color: #17a2b8;
    color: white;
  }

  /* CSS cho icon trong badge */
  .badge i {
    font-size: 0.8em;
  }

  /* Đảm bảo table-primary không ghi đè highlighting */
  .table-primary.old-debt-row {
    background-color: #fff3cd !important;
  }

  .table-primary.new-debt-row {
    background-color: #b8daff !important; /* Màu xanh đậm hơn cho dòng đầu tiên */
    border-left: 4px solid #007bff !important;
  }

  /* CSS cho button xóa */
  .btn-outline-danger:hover {
    transform: scale(1.05);
    transition: transform 0.2s ease;
  }

  /* CSS cho icon khóa */
  .text-muted i {
    opacity: 0.6;
  }

  /* Animation cho highlighting */
  .old-debt-row, .new-debt-row {
    transition: all 0.3s ease;
  }

  /* CSS cho tooltip */
  [title] {
    cursor: help;
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    .old-debt-row, .new-debt-row {
      border-left-width: 2px !important;
    }

    .badge {
      font-size: 0.65rem;
      padding: 0.2em 0.4em;
    }
  }
</style>
